<div class="snackbar-content">
  <div class="snackbar-title">{{ data.title }}</div>
  <mat-icon>{{ data.icon }}</mat-icon>
  <p class="snackbar-message">{{ data.message }}</p>
  <!--<ul>
    <li *ngFor="let item of data.items">{{ item }}</li>
  </ul>-->
</div>
